// extracted by mini-css-extract-plugin
module.exports = {"AdSlotOffsite":"bge_a bha_bi"};